export default __webpack_public_path__ + "locales/nl/PeopleTranslations.json?hash=07c41dac2c1b985373a7dad0032fa49a";